/*
 * @Description:
 * @Author: ZY
 * @Date: 2021-01-08 17:56:34
 * @LastEditors: ZY
 * @LastEditTime: 2021-01-08 19:01:43
 */
// Parse the time to string
import dayjs from 'dayjs'
import $number from 'number-precision'
import currency from 'currency.js'
$number.enableBoundaryChecking(false)
export const parseTime = (
  time?: object | string | number | null,
  cFormat?: string
): string | null => {
  if (time === undefined || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date: Date
  if (typeof time === 'object') {
    date = time as Date
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj: { [key: string]: number } = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return timeStr
}

// Format and filter json data using filterKeys array
export const formatJson = (filterKeys: any, jsonData: any) =>
  jsonData.map((data: any) => filterKeys.map((key: string) => {
    if (key === 'timestamp') {
      return parseTime(data[key])
    } else {
      return data[key]
    }
  }))

// Check if an element has a class
export const hasClass = (ele: HTMLElement, className: string) => {
  return !!ele.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))
}

// Add class to element
export const addClass = (ele: HTMLElement, className: string) => {
  if (!hasClass(ele, className)) ele.className += ' ' + className
}

// Remove class from element
export const removeClass = (ele: HTMLElement, className: string) => {
  if (hasClass(ele, className)) {
    const reg = new RegExp('(\\s|^)' + className + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// Toggle class for the selected element
export const toggleClass = (ele: HTMLElement, className: string) => {
  if (!ele || !className) {
    return
  }
  let classString = ele.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  ele.className = classString
}

export const defaultDate = [
  dayjs(new Date().getTime() - 3600 * 1000 * 24 * 180).format('YYYY-MM-DD'), dayjs(new Date().getTime()).format('YYYY-MM-DD')
]

export const defaultDateTwoYears = [
  dayjs(new Date().getTime() - 3600 * 1000 * 24 * 730).format('YYYY-MM-DD'), dayjs(new Date().getTime()).format('YYYY-MM-DD')
]

export const defaultDateFiveYears = [
  dayjs(new Date().getTime() - 3600 * 1000 * 24 * 1825).format('YYYY-MM-DD'), dayjs(new Date().getTime()).format('YYYY-MM-DD')
]

// 函数而非常量：页面长时间不刷新时，每次打开/重置仍能取到当天所在月份
export const getCurrentMonthRange = () => {
  const now = dayjs()
  return {
    startTime: now.startOf('month').format('YYYY-MM-DD'),
    endTime: now.format('YYYY-MM-DD')
  }
}

export const InitDate = dayjs(new Date(1970).getTime() - 3600 * 1000 * 24 * 180).format('YYYY-MM-DD')

export const Today = dayjs(new Date().getTime()).format('YYYY-MM-DD')

export const numberTimes = <T extends boolean>(price: any, amount: any, isCurrency: boolean): T extends true ? currency : number => {
  const priceNum = price ? price * 1 : 0
  const amountNum = amount ? amount * 1 : 0
  if (isCurrency) {
    return currency($number.times(priceNum, amountNum)) as T extends true ? currency : number
  } else {
    return $number.times(priceNum, amountNum) as T extends true ? currency : number
  }
}

export const priceWithoutRate = <T extends boolean>(price: any, isCurrency: boolean, taxRate: number): T extends true ? currency : number => {
  const priceNum = price ? price * 1 : 0
  taxRate = taxRate ? $number.divide(taxRate, 100) : 0
  taxRate = $number.plus(taxRate, 1)
  if (isCurrency) {
    return currency($number.divide(priceNum, taxRate)) as T extends true ? currency : number
  } else {
    return $number.divide(priceNum, taxRate) as T extends true ? currency : number
  }
}
export const totalPriceWithoutRate = <T extends boolean>(price: any, amount: any, isCurrency: T, taxRate: number): T extends true ? currency : number => {
  let priceNum = price ? price * 1 : 0
  const amountNum = amount ? amount * 1 : 0
  taxRate = taxRate ? $number.divide(taxRate, 100) : 0
  taxRate = $number.plus(taxRate, 1)
  priceNum = $number.divide(priceNum, taxRate)
  if (isCurrency) {
    return currency($number.times(priceNum, amountNum)) as T extends true ? currency : number
  } else {
    return $number.times(priceNum, amountNum) as T extends true ? currency : number
  }
}

export const handleCalcTotal = (array: any, taxRate: number, price: any, amount: any) => {
  return array.map((item: any) => {
    return {
      ...item,
      totalPrice: numberTimes(item[price], item[amount], true),
      totalPriceWithRate: totalPriceWithoutRate(item[price], item[amount], true, taxRate)
    }
  })
}

export const corporateList = [
  { name: '对公转账', id: 1 },
  { name: '对私转账', id: 2 }
]

export const payTypeList = [
  { name: '微信', id: 1 },
  { name: '支付宝', id: 2 },
  { name: '银行卡', id: 3 },
  { name: '现金', id: 4 }
]

export const pageVo = {
  page: 1,
  size: 200
}

export const pageVoTen = {
  page: 1,
  size: 10
}
export const pageSizes = [10, 20, 50, 100, 200]
